import { Component, Input } from '@angular/core';
import { Vendor } from '../uig-product.models';

@Component({
    selector: 'app-uig-marketplace-icon',
    templateUrl: './uig-marketplace-icon.component.html',
    styleUrls: ['./uig-marketplace-icon.component.scss'],
    standalone: false
})

export class UigMarketplaceIconComponent {
  @Input() marketplace: boolean;
  @Input() vendor: Vendor;
  @Input() displayText: boolean;
}
